(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-product-tools"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dw-product-tools'))customElements.define('dw-product-tools',class extends HTMLElement{
connectedCallback(){
this.ready=()=>this.mount();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.ready,{once:true});else this.mount();
}
mount(){
const id=this.dataset.section;
this.form=document.getElementById('product-form-'+id);
this.original=this.form?.querySelector('[name="add"]');
this.bar=this.querySelector('.dw-sticky-buy');this.button=this.querySelector('[data-dw-sticky-button]');
if(!this.original||!this.bar||!this.button)return;
this.sync=()=>{this.button.disabled=this.original.disabled||this.original.classList.contains('loading');const label=this.original.querySelector('span');if(label)this.button.textContent=label.textContent.trim();const priceRoot=document.getElementById('price-'+id);const price=priceRoot?.querySelector(priceRoot.querySelector('.price--on-sale')?'.price-item--sale':'.price-item--regular');if(price)this.querySelector('[data-dw-sticky-price]').textContent=price.textContent.trim();};
this.button.addEventListener('click',()=>{if(this.original.disabled)return;this.form.scrollIntoView({block:'center',behavior:'smooth'});this.original.click();});
this.observer=new MutationObserver(this.sync);this.observer.observe(this.original,{subtree:true,attributes:true,childList:true,characterData:true});
const price=document.getElementById('price-'+id);if(price)this.observer.observe(price,{subtree:true,childList:true,characterData:true});
this.intersection=new IntersectionObserver(es=>{for(const e of es)this.bar.hidden=e.isIntersecting||e.boundingClientRect.bottom>0;},{threshold:0});this.intersection.observe(this.original);
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{if(String(event.data.sectionId)!==id)return;const source=event.data.html?.getElementById('DwFacts-'+id);const destination=document.getElementById('DwFacts-'+id);if(source&&destination)destination.innerHTML=source.innerHTML;this.sync();});
this.sync();
}
disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this.ready);this.observer?.disconnect();this.intersection?.disconnect();this.unsubscribe?.();}
});
  } catch(e) { console.error(e); }
})();

})();
